import { CalendarPlus, AlertTriangle } from "lucide-react";

const btn = "inline-flex items-center gap-1.5 text-sm px-3 py-2 rounded-lg border border-slate-200 bg-white text-slate-700 hover:bg-slate-50 transition-colors";

export const AddToCalendar = ({ cal, icsHref, onIcs, onAdded, testid = "cal" }) => {
  if (!cal) return null;
  const google = () => { window.open(cal.google_url, "_blank", "noopener"); onAdded?.(); };
  return (
    <div className="space-y-2" data-testid={`${testid}-box`}>
      {cal.changed && (
        <div className="flex items-center gap-2 text-sm rounded-lg px-3 py-2 bg-amber-50 border border-amber-200 text-amber-900" data-testid={`${testid}-changed`}>
          <AlertTriangle size={15} className="shrink-0" /> Data alterada: volte a adicionar ao calendário.
        </div>
      )}
      <div className="flex flex-wrap items-center gap-2">
        <span className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600"><CalendarPlus size={15} /> Adicionar ao calendário</span>
        <button type="button" onClick={google} className={btn} data-testid={`${testid}-google`}>Google Calendar</button>
        {icsHref ? (
          <a href={icsHref} className={btn} data-testid={`${testid}-ics`} onClick={() => setTimeout(() => onAdded?.(), 800)}>Outlook / iPhone (.ics)</a>
        ) : (
          <button type="button" onClick={onIcs} className={btn} data-testid={`${testid}-ics`}>Outlook / iPhone (.ics)</button>
        )}
      </div>
    </div>
  );
};
